import ContactUsForm from "@components/BasicComponents/Forms/ContactUsForm/ContactUsForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ContactUsFormSection.module.scss"

const ContactUsFormSection = (props: {data: AdvancedSideAssetModuleType}) => {
	return (
		<section id={"contact-us"}>
			<ContainerWrapper id={"book-a-demo"}>
				<Separator size={128}>
					<Title
						content={props.data.sectionTitle}
						size={"XL"}
						center
					/>
					<Separator />
					<div className={styles.formContainer}>
						<ContactUsForm />
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsFormSection
